/**=========================================================
 * Module: app-fileinput.js
 * Handles file input
 =========================================================*/

 App.directive('appFileInput', ['$timeout',function ($timeout) {
  'use strict';

  return {
      templateUrl: 'app/views/partials/fileinput.html',
      restrict: 'E',
      replace: true,
      controller: 'UploadFileController',
      scope: {
        field: '=',
        form: '='
      },
      link: function postLink(scope, element, attrs) {
        $timeout(function(){
          var fileId = scope.fileId;
          var progressbar = $('#progressbar_'+fileId),
          bar         = progressbar.find('.progress-bar');
          var uuid = function(){
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
              var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
              return v.toString(16);
            });
          }
          var yyyymmdd = function(d) {
            var mm = d.getMonth() + 1; // getMonth() is zero-based
            var dd = d.getDate();
          
            return [d.getFullYear(),
                    (mm>9 ? '' : '0') + mm,
                    (dd>9 ? '' : '0') + dd
                   ].join('');
          };
          var hhmmss = function(d) {
            var hh = d.getHours();
            var mm = d.getMinutes();
            var ss = d.getSeconds();

            return [(hh>9 ? '' : '0') + hh,
                    (mm>9 ? '' : '0') + mm,
                    (ss>9 ? '' : '0') + ss
                    ].join('');
          };
          var T = function(d){
            return yyyymmdd(d) + hhmmss(d);
          }

          var settings    = {

              fileId: fileId,
              baseUrl: CONFIG.baseUrl,
              url: CONFIG.functionsUrl,
              
              filename: scope.field.filepath || [ scope.form.type || '_type', scope.form.model.id || scope.form.model.tempId || '_id', scope.field.name || '_field', T(new Date())].join('/'),
              bucket: scope.field.bucket || scope.form.bucket,
              objectType: scope.form.type,
              objectId: scope.form.model.id || scope.form.model.tempId,
              objectField: scope.field.name,
              public: scope.field.public,

              action: $('#upload-form_'+fileId).attr('action'), // upload url

              //allow : '*.(jpg|jpeg|gif|png)', // allow only images
              //allow : '*.*', // allow all
              allow: '*.' + $('#upload-form-allow_'+fileId).val(),
              
              notallowed: function(file, settings){
                $('#notallowed-error_'+fileId).show();
              },
              
              maxSize: parseInt($('#upload-form-max_'+fileId).val()),

              limit: scope.field.limit,
              tooManyFiles: function(length, settings){
                $('#toomanyfiles-error_'+fileId).show();
              },
              
              exceededSize: function(file, settings){
                $('#exceededsize-error_'+fileId).show();
              },

              param: 'uploaded_files',
              
              type: 'json',

              init: function(){
                  scope.error = false;
                  bar.css('width', '0%').text('0%');
                  $('#progressloaded_'+fileId).text('-');
                  $('#progresstotal_'+fileId).text('-');
                  $('#progressuploaded_'+fileId).text('');
                  $('#progressfiles_'+fileId).text('');
                  $('#uploaded_'+fileId).hide();
                  $('#overwritten_'+fileId).hide();
              },

              loadstart: function() {
                  scope.uploaded = true;
                  scope.error = false;
                  $('#uploaded_'+fileId).hide();
                  $('#overwritten_'+fileId).hide();
                  $('#upload-drop_'+fileId).hide();
                  $('#uploading_'+fileId).show();
                  //bar.css('width', '0%').text('0%');
                  progressbar.removeClass('hidden');
                  $('#progresscounter_'+fileId).removeClass('hidden');
              },
              
              progress: function(percent, e, fileCounters) {
                  if(!e) e = { loaded: 0, total: 0}; 
                  percent = Math.ceil(percent);
                  bar.css('width', percent+'%').text(percent+'%');
                  
                  if (percent==100) {
                    bar.text($('#completedText_'+fileId).text());
                  }
                  
                  var bytes = function(bytes){
                    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
                      var precision = 1;
                      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                              number = Math.floor(Math.log(bytes) / Math.log(1024));
                      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];  
                  };
                  
                  $('#progressloaded_'+fileId).text(bytes(e.loaded));
                  $('#progresstotal_'+fileId).text(bytes(e.total));
                  if(fileCounters && fileCounters.files>1){
                    $('#progresscounterfiles_'+fileId).removeClass('hidden');
                    $('#progressuploaded_'+fileId).text(fileCounters.uploaded+1);
                    $('#progressfiles_'+fileId).text(fileCounters.files);
                  } else {
                    $('#progresscounterfiles_'+fileId).addClass('hidden');
                  }
                  scope.loaded = e.loaded;
                  scope.total = e.total;
                  if (e.loaded==e.total) {
                    $('#progresscounterdone_'+fileId).show();
                  }
              },

              allcomplete: function(response) {

                  var data = response && angular.fromJson(response);
                  bar.css('width', '100%').text('100%');

                  setTimeout(function(){
                      $('#progresscounter_'+fileId).addClass('hidden');
                      progressbar.addClass('hidden');
                  }, 250);

                  // Upload Completed
                  if(data && data.length) {
                    var hasErrors = false;
                    for(var i=0; i<data.length; i++){
                      if(data[i].error) {
                        hasErrors = true;
                        if(Rollbar && Rollbar.Rollbar && Rollbar.error){
                          Rollbar.error('Upload error', data[i].error)
                        }
                      }
                      if(data[i].errorLabel) scope.errorLabel = data[i].errorLabel
                    }
                    if(!hasErrors){
                      $('#uploaded_'+fileId).show();
                    } else {
                      scope.error = true;
                    }
                    $('#upload-drop_'+fileId).show();
                    $('#uploading_'+fileId).hide();
                    for(var i=0; i<data.length; i++){
                      scope.$parent.uploadedFile(data[i], fileId);
                    }
                    setTimeout(function(){
                      $('#refresh_'+fileId).trigger('click');
                    }, 
                    1000);
                    setTimeout(function(){
                      $('#refresh_'+fileId).trigger('click');
                    }, 
                    5000);
                  }
              }
          };

          var select = new $.upload.select($('#upload-select_'+fileId), settings),
              local = new $.upload.local($('#upload-fromlocal_'+fileId), settings),
              aslink = new $.upload.aslink($('#upload-link_'+fileId), settings),
              drop   = new $.upload.drop($('#upload-drop_'+fileId), settings);
        },50);
    }
  }

}]);
